var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.952 15.068a.75.75 0 0 0-.623 1.364zM12 16v.75h.013zm3.998-4.235h.75zM8.04 14.888a.75.75 0 0 0 1.232-.857zm.554 5.363a.75.75 0 1 0 1.468.31zm3.342-8.549a.75.75 0 1 0-1.468-.31zm-1.607 4.73c.643.294 1.073.319 1.673.318L12 15.25c-.503 0-.686-.017-1.048-.182zm1.685.318c2.674-.046 4.735-2.18 4.735-4.985h-1.5c0 2.026-1.444 3.454-3.261 3.485zm4.735-4.985c0-1.952-1.781-4.515-4.748-4.515v1.5c2.032 0 3.248 1.78 3.248 3.015zM12.001 7.25c-2.948 0-4.75 2.385-4.751 4.515h1.5c0-1.372 1.2-3.015 3.251-3.015zM7.25 11.765c0 .97.182 1.73.372 2.258.095.264.192.469.27.614a3 3 0 0 0 .14.24l.005.006.002.002v.002l.617-.428.616-.427.001.001.001.002.002.002q0 .001 0 0a1 1 0 0 1-.06-.104 3 3 0 0 1-.183-.419 5.2 5.2 0 0 1-.283-1.75zm2.812 8.796 1.874-8.859-1.468-.31-1.874 8.86z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 9
  })));
};
export default SvgPinterest;